import React from "react";

import { getUserData, isAuthenticated } from "@api/auth/auth";
import { UserData } from "@types";
interface IUserContext {
  user?: UserData;
}

export const UserContext = React.createContext<IUserContext>({});

export const UserProvider: React.FC = ({ children }) => {
  const user = isAuthenticated() ? getUserData() : undefined;

  return (
    <UserContext.Provider value={{ user }}>{children}</UserContext.Provider>
  );
};
